import React, { useContext } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import i18n from "i18n"
import SubscriptionContext from "context/subscription/subscriptionContext"

const ADVICE_BAR_HEIGHT = 47
/** Left offset so the bar sits to the right of the sidebar (sidebar is first, full height). */
const SIDEBAR_COLLAPSED_WIDTH = 60

/**
 * Fixed top bar shown when user is on trial or has no subscription.
 * Prompts to upgrade; can be dismissed via SubscriptionContext.
 */
function TopAdviceBar({ leftOffset = SIDEBAR_COLLAPSED_WIDTH }) {
  const navigate = useNavigate()
  const { isTrial, noSubscription, daysLeft, setShowTopAdviceBar } =
    useContext(SubscriptionContext)

  const daysLeftMessage = () => {
    if (noSubscription || daysLeft < 0) {
      return i18n.t("No tienes suscripcion activa")
    }
    if (isTrial && daysLeft < 30) {
      return (
        i18n.t("Te quedan ") + daysLeft + i18n.t(" dias de prueba gratuita")
      )
    }
    return ""
  }

  const handleUpgrade = () => {
    navigate("/subscription")
    window.location.reload()
  }

  const handleClose = () => {
    setShowTopAdviceBar(false)
  }

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 0,
        left: leftOffset,
        right: 0,
        height: ADVICE_BAR_HEIGHT,
        minHeight: ADVICE_BAR_HEIGHT,
        backgroundColor: "#5984FC",
        zIndex: 999,
        "& .MuiToolbar-root": {
          minHeight: ADVICE_BAR_HEIGHT,
          height: ADVICE_BAR_HEIGHT,
          paddingLeft: 2,
          paddingRight: 1,
        },
      }}
    >
      <Toolbar>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            gap: 0.5,
          }}
        >
          <Typography
            component="span"
            sx={{ color: "white", fontWeight: 300, fontSize: 14 }}
          >
            {daysLeftMessage()}
          </Typography>
          <Typography
            component="span"
            onClick={handleUpgrade}
            sx={{
              color: "white",
              fontWeight: 600,
              fontSize: 14,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {i18n.t(" Actualiza tu plan y consigue acceso completo.")}
          </Typography>
        </Box>
        <IconButton
          size="small"
          onClick={handleClose}
          sx={{ color: "white" }}
          aria-label={i18n.t("Cerrar")}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

TopAdviceBar.propTypes = {
  leftOffset: PropTypes.number,
}

export default TopAdviceBar
export { ADVICE_BAR_HEIGHT, SIDEBAR_COLLAPSED_WIDTH }
